<template>
  <footer class="block py-4">
    <div class="container mx-auto px-4">
      <hr class="mb-4 border-b-1 border-blueGray-200" />
      <div class="flex flex-wrap items-center md:justify-between justify-center">
        <div class="w-full md:w-4/12 px-4">
          <div class="text-sm text-blueGray-500 py-1 text-center md:text-left text-sm">
            <span>v{{ version }}</span>
            <span v-if="systemVersion"> (API v{{ systemVersion }})</span>
            <a href="https://www.engapa.com/" target="_blank" class="text-blueGray-600 text-blueGray-800">
              Engapa
            </a>
          </div>
        </div>
        <div class="w-full md:w-8/12 px-4">
          <ul class="flex flex-wrap list-none md:justify-end justify-center">
            <li class="text-sm text-blueGray-500">
              <span>© {{ date }}</span>
              <a href="https://zarasa.io" target="_blank" class="text-blueGray-600 hover:text-blueGray-700">
                Zarasa
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      date: new Date().getFullYear(),
      version: process.env.VUE_APP_VERSION
    };
  },

  computed: {
    ...mapState({
      userInfo: state => state.auth.user
    }),

    systemVersion() {
      return this.userInfo?.systemVersion;
    }
  }
};
</script>
